/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Secure/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Secure({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/InApp/Content/Outbound/Secure"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let inAppIsSecureValueData = fromData.useDataValue({ viewPath,
context: 'in_app',
path: 'is_secure',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(inAppIsSecureValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}